import request from '@/utils/request';

export default {
  /**
     * 获取用户信息
     */
  getUserList() {
    return request.get('/user/userList');
  },

  /**
     * 创建用户
     * @param userName
     * @param passerword
     * @param DeptName
     * @return {*}
     */
  createUser(userName, password, deptName) {
    return request.post('/user/createUser', {
      userName, password, deptName,
    });
  },

  /**
     * 获取角色信息
     */
  getRoleList() {
    return request.get('/user/roleList');
  },

  /**
     * 获取权限行为
     */
  getDroitList() {
    return request.get('/user/droitList');
  },

  /**
     * 用户分配角色
     * @param userId
     * @param roleId
     * @return {*}
     */
  userBindRole(userId, roleId) {
    return request.post('/user/userBindRole', {
      userId, roleId,
    });
  },

  /**
     * 获取设备信息
     */
  getDeviceList() {
    return request.get('/device/list');
  },

  /**
     * 获取项目信息
     */
  getProjectList() {
    return request.get('/project/list');
  },

  /**
     * 用户分配设备
     * @param userId
     * @param deviceList
     * @return {*}
     */
  deviceAllocate(userId, deviceList) {
    return request.post('/user/deviceAllocation', {
      userId, deviceList,
    });
  },

  /**
     * 用户分配项目
     * @param userId
     * @param projectList
     * @return {*}
     */
  projectAllocate(userId, projectList) {
    return request.post('/user/projectAllocation', {
      userId, projectList,
    });
  },

  /**
     * 查询用户可控设备
     */
  controlDevice(url) {
    return request.post(url);
  },

  /**
     * 查询用户可控项目
     */
  controlProject(url) {
    return request.post(url);
  },

  /**
     * 创建角色
     * @param roleName
     * @param droitId
     * @return {*}
     */
  createRole(roleName, droitId) {
    return request.post('/user/createRole', {
      roleName, droitId,
    });
  },

  /**
     * 查询用户的设备列表
     */
  getUserDeviceList(url) {
    return request.get(url);
  },

  /**
     * 查询用户权限
     */
  getRoleDroit(url) {
    return request.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/api/authority.js